module.exports = __webpack_public_path__ + "img/logo_santander2.6cc45cc3.svg";